(function () {
  var WRAP = '[id*="klaviyo_reviews_product_reviews"]';
  var ITEM = '.kl_reviews__review_item';

  function liveItems(wrap) {
    return [].filter.call(wrap.querySelectorAll(ITEM), function (i) { return !i.closest('.sp-rv-ghost'); });
  }

  var BOX = '.kl_reviews__list';
  var EMPTY = '[class*="list_empty_state"]';
  var OVERLAY = '.kl_reviews__list_loading__overlay';
  var DUPE = 'data-sp-kr-dupe';
  var STALE = 'data-sp-kr-stale';
  var HOLD = 'data-sp-kr-hold';

  var SETTLE_MS = 350;

  var MAX_HOLD_MS = 8000;

  function signature(el) {
    var stars = el.querySelector('[aria-label]');
    return (stars ? stars.getAttribute('aria-label') : '') + '|' +
      el.textContent.replace(/\s+/g, ' ').trim();
  }

  function dedupe(wrap) {
    var items = liveItems(wrap);
    var seen = {};
    for (var i = 0; i < items.length; i++) {

      var key = 'r:' + signature(items[i]);
      if (seen[key]) {
        items[i].setAttribute(DUPE, '1');
      } else {
        seen[key] = 1;
        if (items[i].hasAttribute(DUPE)) items[i].removeAttribute(DUPE);
      }
    }
  }

  function hideStale(wrap) {
    var input = wrap.querySelector('input.kl_reviews__input_with_search_icon');
    var v = input ? (input.value || '').trim().toLowerCase() : '';
    var active = v.length >= 2 && window.__spKrRefined === v;
    var items = liveItems(wrap);
    for (var i = 0; i < items.length; i++) {
      var stale = active && !hasWordPrefix(items[i].textContent, v);
      if (stale) {
        if (!items[i].hasAttribute(STALE)) items[i].setAttribute(STALE, '1');
      } else if (items[i].hasAttribute(STALE)) {
        items[i].removeAttribute(STALE);
      }
    }
  }

  function makeHolder(wrap) {
    var lastHeight = 0;
    var settleTimer = null;
    var maxTimer = null;

    function clearTimers() {
      if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
      if (maxTimer) { clearTimeout(maxTimer); maxTimer = null; }
    }

    function release(box) {
      clearTimers();
      if (!box.hasAttribute(HOLD)) return;
      box.style.minHeight = '';
      box.removeAttribute(HOLD);
    }

    return function apply() {
      var box = wrap.querySelector(BOX);
      if (!box) return;

      if (box.querySelector(ITEM)) {
        release(box);

        var h = box.getBoundingClientRect().height;
        if (h > 0) lastHeight = h;
        return;
      }

      if (lastHeight > 0 && !box.hasAttribute(HOLD)) {
        box.style.minHeight = lastHeight + 'px';
        box.setAttribute(HOLD, '1');
        maxTimer = setTimeout(function () {
          var b = wrap.querySelector(BOX);
          if (b) release(b);
        }, MAX_HOLD_MS);
      }

      if (!box.hasAttribute(HOLD)) return;
      if (settleTimer) clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        settleTimer = null;
        var b = wrap.querySelector(BOX);
        if (!b) return;
        if (!b.querySelector(ITEM) && !b.querySelector(OVERLAY)) release(b);
      }, SETTLE_MS);
    };
  }

  function isWordChar(ch) {
    return !!ch && /[^\s!-\/:-@\[-`{-~\u2000-\u206f\u2e00-\u2e7f]/.test(ch);
  }

  function startsWord(hay, at) {
    return !isWordChar(hay.charAt(at - 1));
  }

  function hasWordPrefix(text, needle) {
    if (!text) return false;
    var hay = String(text).toLowerCase();
    var at = hay.indexOf(needle);
    while (at !== -1) {
      if (startsWord(hay, at)) return true;
      at = hay.indexOf(needle, at + 1);
    }
    return false;
  }

  function installFetchGuard() {
    if (!window.fetch || !window.Response || window.__spKrFetchGuard) return;
    window.__spKrFetchGuard = 1;

    var LIST = /\/reviews\/api\/client_reviews\//;
    var GROUPED = /\/grouped_id\//;
    var TIMEOUT_MS = 10000;
    var seq = 0;
    var waiters = [];
    var original = window.fetch;

    var published = { n: 0, text: null };

    function publish(n, text) {
      if (n !== seq) return;
      published = { n: n, text: text };
      var pending = waiters;
      waiters = [];
      for (var i = 0; i < pending.length; i++) pending[i](text);
    }

    function waitForNewest() {
      return new Promise(function (resolve) {
        var done = false;
        var fn = function (text) { if (!done) { done = true; resolve(text); } };
        waiters.push(fn);
        setTimeout(function () { fn(null); }, TIMEOUT_MS);
      });
    }

    function answerWithNewest(text, res) {
      if (published.n === seq && published.text != null) {
        return Promise.resolve(respond(published.text, res));
      }
      return waitForNewest().then(function (newest) {
        return respond(newest == null ? text : newest, res);
      });
    }

    function respond(text, res) {

      return new Response(text, {
        status: res.status,
        statusText: res.statusText,
        headers: { 'content-type': res.headers.get('content-type') || 'application/json' }
      });
    }

    var MAX_SCAN = 300;

    var refinedNeedle = '';
    var PAGE = 50;
    var scanCache = {};

    function paramsOf(url) {
      var q = url.indexOf('?');
      var out = {};
      if (q === -1) return out;
      var parts = url.slice(q + 1).split('&');
      for (var i = 0; i < parts.length; i++) {
        var kv = parts[i].split('=');
        out[decodeURIComponent(kv[0])] = decodeURIComponent((kv[1] || '').replace(/\+/g, ' '));
      }
      return out;
    }

    function withPaging(url, limit, offset) {
      return url
        .replace(/([?&])limit=[^&]*/, '$1limit=' + limit)
        .replace(/([?&])offset=[^&]*/, '$1offset=' + offset);
    }

    function matches(review, needle) {
      return hasWordPrefix(review.content, needle) ||
        hasWordPrefix(review.title, needle) ||
        hasWordPrefix(review.author, needle);
    }

    function scanAll(url, first) {
      var rows = (first.reviews || []).slice();
      var total = typeof first.filtered_count === 'number' ? first.filtered_count : rows.length;

      function more(offset) {
        if (offset >= total || offset >= MAX_SCAN) return Promise.resolve(rows);
        return original(withPaging(url, PAGE, offset), { credentials: 'omit' })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var page = d.reviews || [];
            rows = rows.concat(page);
            if (!page.length) return rows;
            return more(offset + page.length);
          })
          ['catch'](function () { return null; });
      }

      rows = [];
      return more(0);
    }

    function helpfulOn(p) {
      return !!window.__spKrHelpful && p.type === 'reviews' &&
        typeof window.spRvHelpfulCounts === 'function' && typeof window.spRvIdFor === 'function';
    }

    function byHelpful(rows) {
      return window.spRvHelpfulCounts().then(function (counts) {
        var score = function (r) { return counts[window.spRvIdFor(r.author, r.content)] || 0; };
        var keyed = rows.map(function (r, i) { return { r: r, s: score(r), i: i }; });
        keyed.sort(function (a, b) { return b.s - a.s || a.i - b.i; });
        return keyed.map(function (k) { return k.r; });
      })['catch'](function () { return rows; });
    }

    function refine(url, text, needle) {
      var data;
      try { data = JSON.parse(text); } catch (e) { return Promise.resolve(text); }
      if (!data || !data.reviews) return Promise.resolve(text);

      var p = paramsOf(url);
      var limit = parseInt(p.limit, 10) || 5;
      var offset = parseInt(p.offset, 10) || 0;
      var total = typeof data.filtered_count === 'number' ? data.filtered_count : data.reviews.length;
      if (total > MAX_SCAN) return Promise.resolve(text);

      var helpful = helpfulOn(p);

      var key = needle + '|' + Object.keys(p).filter(function (k) { return k !== 'offset' && k !== 'limit' && k !== 'filter'; })
        .sort().map(function (k) { return k + '=' + p[k]; }).join('&');
      var have = scanCache[key] ? Promise.resolve(scanCache[key]) : scanAll(url, data);

      return have.then(function (all) {
        if (!all) return text;
        scanCache[key] = all;
        refinedNeedle = needle;
        var kept = [];
        for (var i = 0; i < all.length; i++) {
          if (!needle || matches(all[i], needle)) kept.push(all[i]);
        }
        return helpful ? byHelpful(kept) : kept;
      }).then(function (kept) {
        if (typeof kept === 'string') return kept;
        data.reviews = kept.slice(offset, offset + limit);
        data.filtered_count = kept.length;
        data.has_more = offset + limit < kept.length;
        return JSON.stringify(data);
      })['catch'](function () { return text; });
    }

    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!LIST.test(url) || GROUPED.test(url)) {
        return original.apply(this, arguments);
      }
      var mine = ++seq;
      return original.apply(this, arguments).then(function (res) {
        return res.clone().text().then(function (text) {
          if (mine < seq) return answerWithNewest(text, res);
          var needle = (paramsOf(url).filter || '').trim().toLowerCase();
          if (needle.length < 2) needle = '';
          var work = needle || helpfulOn(paramsOf(url)) ? refine(url, text, needle) : Promise.resolve(text);
          return work.then(function (finalText) {

            if (mine < seq) return answerWithNewest(finalText, res);
            window.__spKrRefined = needle && refinedNeedle === needle ? needle : '';
            publish(mine, finalText);
            return respond(finalText, res);
          });
        });
      });
    };
  }

  function installLightboxDismiss() {
    if (window.__spKrLightbox) return;
    window.__spKrLightbox = 1;

    var BG = 'kl_reviews__lightbox_background';
    var PANEL = '.kl_reviews__lightbox__content_wrapper';
    var STRIP = '.kl_reviews__lightbox__image_list';
    var startedInside = false;

    function isBackdrop(el) {
      return el && el.classList && el.classList.contains(BG);
    }

    document.addEventListener('mousedown', function (e) {
      startedInside = !isBackdrop(e.target);
    }, true);

    document.addEventListener('click', function (e) {
      if (!isBackdrop(e.target)) return;
      if (startedInside) { startedInside = false; return; }

      var bg = e.target;
      var panel = bg.querySelector(PANEL);
      var strip = bg.querySelector(STRIP);
      if (hit(panel, e) || hit(strip, e)) return;
      var close = bg.querySelector('.kl_reviews__close_button');
      if (close) close.click();
    }, true);

    function hit(el, e) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return e.clientX >= r.left && e.clientX <= r.right &&
             e.clientY >= r.top && e.clientY <= r.bottom;
    }
  }

  function makeHighlighter(wrap) {
    var supported = typeof window.CSS !== 'undefined' && window.CSS.highlights &&
      typeof window.Highlight === 'function';
    if (!supported) return function () {};

    var NAME = 'sp-kr-hit';
    var FIELDS = '.kl_reviews__review__content, .kl_reviews__review__title';

    function term() {
      var input = wrap.querySelector('input.kl_reviews__input_with_search_icon');
      var v = input ? (input.value || '').trim() : '';
      return v.length >= 2 ? v.toLowerCase() : '';
    }

    return function () {
      var needle = term();
      if (!needle) { window.CSS.highlights['delete'](NAME); return; }

      var ranges = [];
      var fields = wrap.querySelectorAll(FIELDS);
      for (var f = 0; f < fields.length; f++) {
        var walker = document.createTreeWalker(fields[f], NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          var hay = node.textContent.toLowerCase();
          var from = hay.indexOf(needle);
          while (from !== -1) {
            if (startsWord(hay, from)) {
              var r = document.createRange();
              r.setStart(node, from);
              r.setEnd(node, from + needle.length);
              ranges.push(r);
            }
            from = hay.indexOf(needle, from + 1);
          }
        }
      }

      if (!ranges.length) { window.CSS.highlights['delete'](NAME); return; }

      var Ctor = Function.prototype.bind.apply(window.Highlight, [null].concat(ranges));
      window.CSS.highlights.set(NAME, new Ctor());
    };
  }

  var ROTATE = {

    'de383309-5aeb-43c1-ba6d-4a1c87bbe37a': -90,

    '4fc75389-2c42-4ee9-b071-f3947b43ff93': -90,
    '87c0f795-433e-4e01-881b-a1b8aff70c89': -90,
    'd0848d33-062e-4b17-8437-7b4562262bf0': -90,
    'b3a7b904-66b8-477f-bedd-220fa3cc3747': -90,
    'cb051588-edb0-43d0-bf6f-cb48eef83caa': -90,
    'b3b75896-6e07-49a4-849c-838988f70921': -90,
    'd32f8007-d6da-431b-8fa9-1c337d08dc4b': -90,
    '97760f04-787a-4f2e-8136-a53f45c766f2': -90  // Lori A.
  };
  window.spKrRotationFor = function (el) { return rotationFor(el); };

  function rotationFor(el) {
    var src = el.currentSrc || el.getAttribute('src') || '';
    if (!src) {
      var source = el.querySelector && el.querySelector('source');
      if (source) src = source.getAttribute('src') || '';
    }
    for (var uuid in ROTATE) {
      if (Object.prototype.hasOwnProperty.call(ROTATE, uuid) && src.indexOf(uuid) !== -1) {
        return ROTATE[uuid];
      }
    }
    return 0;
  }

  var BAR = 'sp-kr-vbar';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M7 5h4v14H7zM13 5h4v14h-4z" fill="currentColor"/></svg>';
  var ICON_SOUND = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16.5 8.5a5 5 0 0 1 0 7"/></svg>';
  var ICON_MUTED = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M17 9l4 6M21 9l-4 6"/></svg>';

  function clock(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var sec = Math.floor(t % 60);
    return m + ':' + (sec < 10 ? '0' : '') + sec;
  }

  function syncBar(v) {
    var bar = v.parentElement && v.parentElement.querySelector('.' + BAR);
    if (!bar) return;
    var play = bar.querySelector('[data-sp-kr-v="play"]');
    var mute = bar.querySelector('[data-sp-kr-v="mute"]');
    var seek = bar.querySelector('[data-sp-kr-v="seek"]');
    var time = bar.querySelector('[data-sp-kr-v="time"]');
    var playing = !v.paused && !v.ended;
    if (play.getAttribute('data-state') !== String(playing)) {
      play.setAttribute('data-state', String(playing));
      play.innerHTML = playing ? ICON_PAUSE : ICON_PLAY;
      play.setAttribute('aria-label', playing ? 'Pause' : 'Play');
    }
    if (mute.getAttribute('data-state') !== String(v.muted)) {
      mute.setAttribute('data-state', String(v.muted));
      mute.innerHTML = v.muted ? ICON_MUTED : ICON_SOUND;
      mute.setAttribute('aria-label', v.muted ? 'Unmute' : 'Mute');
    }
    var d = v.duration;
    if (!bar.__spKrSeeking) seek.value = isFinite(d) && d > 0 ? String(Math.round(v.currentTime / d * 1000)) : '0';
    time.textContent = clock(v.currentTime) + ' / ' + clock(d);
  }

  function ensureBar(v) {
    var slide = v.parentElement;
    if (!slide) return;
    if (!v.hasAttribute('data-sp-kr-native')) v.setAttribute('data-sp-kr-native', v.controls ? '1' : '0');
    v.controls = false;
    if (!slide.querySelector('.' + BAR)) {
      var bar = document.createElement('div');
      bar.className = BAR;
      bar.innerHTML =
        '<button type="button" data-sp-kr-v="play" aria-label="Play">' + ICON_PLAY + '</button>' +
        '<input type="range" data-sp-kr-v="seek" min="0" max="1000" step="1" value="0" aria-label="Seek">' +
        '<span data-sp-kr-v="time">0:00 / 0:00</span>' +
        '<button type="button" data-sp-kr-v="mute" aria-label="Mute">' + ICON_SOUND + '</button>';
      slide.appendChild(bar);
    }
    if (!v.__spKrBar) {
      v.__spKrBar = 1;
      var sync = function () { syncBar(v); };
      ['timeupdate', 'play', 'pause', 'ended', 'loadedmetadata', 'durationchange', 'volumechange'].forEach(function (ev) {
        v.addEventListener(ev, sync);
      });
    }
    syncBar(v);
  }

  function dropBar(v) {
    var slide = v.parentElement;
    var bar = slide && slide.querySelector('.' + BAR);
    if (bar) bar.parentNode.removeChild(bar);
    if (v.hasAttribute('data-sp-kr-native')) {
      v.controls = v.getAttribute('data-sp-kr-native') === '1';
      v.removeAttribute('data-sp-kr-native');
    }
  }

  var VPLAY = 'sp-kr-vplay';

  var ICON_PLAY_BIG = '<svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M6.667 14.313V5.688a.79.79 0 0 1 .25-.594.817.817 0 0 1 .802-.208c.076.02.149.052.218.093l6.792 4.313a.807.807 0 0 1 .281.312.874.874 0 0 1 0 .792.807.807 0 0 1-.281.313L7.937 15.02a.868.868 0 0 1-.437.125.817.817 0 0 1-.583-.24.79.79 0 0 1-.25-.593Z" fill="#fff"/></svg>';

  function syncPaused(v) {
    var slide = v.parentElement;
    if (!slide) return;
    var paused = v.paused || v.ended;
    if (slide.getAttribute('data-sp-kr-paused') !== String(paused)) slide.setAttribute('data-sp-kr-paused', String(paused));
    if (!slide.querySelector('.' + BAR) && v.getAttribute('data-sp-kr-native-ctl') !== null) {
      v.controls = !paused && v.getAttribute('data-sp-kr-native-ctl') === '1';
    }
  }

  function ensurePlayOverlay(v) {
    var slide = v.parentElement;
    if (!slide) return;

    if (!v.__spKrMutedDefault) {
      v.__spKrMutedDefault = 1;
      v.autoplay = false;
      v.defaultMuted = true;
      v.muted = true;
    }
    if (v.getAttribute('data-sp-kr-native-ctl') === null && !v.hasAttribute('data-sp-kr-native')) {
      v.setAttribute('data-sp-kr-native-ctl', v.controls ? '1' : '0');
    }
    if (!slide.querySelector('.' + VPLAY)) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = VPLAY;
      btn.setAttribute('aria-label', 'Play');
      btn.innerHTML = ICON_PLAY_BIG;
      slide.appendChild(btn);
    }
    if (!v.__spKrPausedWatch) {
      v.__spKrPausedWatch = 1;
      ['play', 'playing', 'pause', 'ended', 'emptied', 'loadedmetadata'].forEach(function (ev) {
        v.addEventListener(ev, function () { syncPaused(v); });
      });
    }
    syncPaused(v);
  }

  function installBar() {
    if (window.__spKrVbar) return;
    window.__spKrVbar = 1;
    var videoOf = function (el) {
      var slide = el.closest('.' + BAR).parentElement;
      return slide && slide.querySelector('video');
    };
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var big = t.closest('.' + VPLAY);
      if (big) {
        e.stopPropagation();
        var bv = big.parentElement && big.parentElement.querySelector('video');
        if (bv) { var bp = bv.play(); if (bp && bp['catch']) bp['catch'](function () {}); }
        return;
      }
      var btn = t.closest('.' + BAR + ' button');
      var turned = !btn && t.closest('video[data-sp-kr-rotated]');
      if (!btn && !turned) return;
      e.stopPropagation();
      var v = btn ? videoOf(btn) : turned;
      if (!v) return;
      var what = btn ? btn.getAttribute('data-sp-kr-v') : 'play';
      if (what === 'play') {
        if (v.paused || v.ended) { var pr = v.play(); if (pr && pr['catch']) pr['catch'](function () {}); } else v.pause();
      } else if (what === 'mute') {
        v.muted = !v.muted;
      }
      syncBar(v);
    }, true);
    document.addEventListener('input', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('.' + BAR + ' [data-sp-kr-v="seek"]')) return;
      var bar = t.closest('.' + BAR);
      var v = videoOf(t);
      if (!v || !isFinite(v.duration)) return;
      bar.__spKrSeeking = true;
      v.currentTime = t.value / 1000 * v.duration;
      clearTimeout(bar.__spKrSeekT);
      bar.__spKrSeekT = setTimeout(function () { bar.__spKrSeeking = false; }, 250);
    }, true);

    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        if (e.target && e.target.closest && e.target.closest('.' + BAR + ', .' + VPLAY)) e.stopPropagation();
      }, true);
    });
  }

  var PLAYING = 'sp-kr-lb-playing';
  var AWAKE = 'sp-kr-lb-awake';
  var HOLD = 'sp-kr-lb-hold';
  var PLAY_MS = 1000;
  var TAP_MS = 2500;
  var NATIVE_BAND = 60;

  function activeVideo(bg) {
    var stage = bg.querySelector('.kl_reviews__lightbox__left');
    var slide = stage && (stage.querySelector('.swiper-slide-active') || stage);
    return slide ? slide.querySelector('video') : null;
  }

  function syncPlaying(bg) {
    var v = activeVideo(bg);
    var on = !!v && !v.paused && !v.ended;
    if (bg.classList.contains(PLAYING) !== on) bg.classList.toggle(PLAYING, on);
  }

  function wake(bg, ms) {
    bg.classList.add(AWAKE);
    clearTimeout(bg.__spKrIdleT);
    bg.__spKrIdleT = setTimeout(function () { bg.classList.remove(AWAKE); }, ms || PLAY_MS);
  }

  function inRect(r, x, y) {
    return !!r && r.width > 0 && r.height > 0 && x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function inControlsBand(bg, x, y) {
    var stage = bg.querySelector('.kl_reviews__lightbox__left');
    var slide = stage && (stage.querySelector('.swiper-slide-active') || stage);
    var bar = slide && slide.querySelector('.' + BAR);
    var strip = bg.querySelector('.kl_reviews__lightbox__image_list');
    if (bar && inRect(bar.getBoundingClientRect(), x, y)) return true;
    if (strip && inRect(strip.getBoundingClientRect(), x, y)) return true;
    if (!bar && stage) {
      var r = stage.getBoundingClientRect();
      if (x >= r.left && x <= r.right && y <= r.bottom && y >= r.bottom - NATIVE_BAND) return true;
    }
    return false;
  }

  function installPlayingWatch() {
    if (window.__spKrPlaying) return;
    window.__spKrPlaying = 1;
    ['play', 'playing', 'pause', 'ended', 'emptied'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var bg = e.target && e.target.closest && e.target.closest('.kl_reviews__lightbox_background');
        if (!bg) return;
        syncPlaying(bg);

        if (!bg.classList.contains(PLAYING) || ev === 'playing' || ev === 'play') wake(bg, PLAY_MS);
      }, true);
    });

    document.addEventListener('pointerout', function (e) {
      if (e.relatedTarget) return;
      var bg = document.querySelector('.kl_reviews__lightbox_background');
      if (bg) bg.classList.remove(HOLD);
    }, { passive: true });
  }

  function watchFade(bg) {
    if (bg.__spKrFade) return;
    bg.__spKrFade = 1;
    bg.addEventListener('pointermove', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') return;
      var on = inControlsBand(bg, e.clientX, e.clientY);
      if (bg.classList.contains(HOLD) !== on) bg.classList.toggle(HOLD, on);
    }, { passive: true });
    bg.addEventListener('pointerdown', function (e) {
      if (e.pointerType && e.pointerType !== 'mouse') wake(bg, TAP_MS);
    }, { passive: true });
    bg.addEventListener('keydown', function () { wake(bg, TAP_MS); }, { passive: true });
    wake(bg, PLAY_MS);
    syncPlaying(bg);

    if (window.MutationObserver) {
      var last = null;
      new MutationObserver(function () {
        var stage = bg.querySelector('.kl_reviews__lightbox__left');
        var now = stage && stage.querySelector('.swiper-slide-active');
        if (now !== last) { last = now; wake(bg, PLAY_MS); }
        syncPlaying(bg);
      }).observe(bg, { attributes: true, attributeFilter: ['class'], subtree: true });
    }
  }

  function layoutLightbox() {
    var bg = document.querySelector('.kl_reviews__lightbox_background');
    if (!bg) return;
    watchFade(bg);

    var stage = bg.querySelector('.kl_reviews__lightbox__left');
    if (stage) {
      var r = stage.getBoundingClientRect();

      bg.style.setProperty('--sp-kr-lb-left', Math.round(r.left) + 'px');
      bg.style.setProperty('--sp-kr-lb-right', Math.round(r.right) + 'px');
      bg.style.setProperty('--sp-kr-lb-mid', Math.round(r.top + r.height / 2) + 'px');

      bg.style.setProperty('--sp-kr-lb-width', Math.round(r.width) + 'px');
      bg.style.setProperty('--sp-kr-lb-bottom', Math.round(r.bottom) + 'px');

      if (window.ResizeObserver) {
        if (!bg.__spKrLayoutObserver) {
          bg.__spKrLayoutObserver = new ResizeObserver(function () { layoutLightbox(); });
        }

        var watch = [stage, stage.parentElement, bg.querySelector('.kl_reviews__lightbox__right'), stage.querySelector('.swiper-slide-active')];
        for (var wi = 0; wi < watch.length; wi++) {
          if (watch[wi]) bg.__spKrLayoutObserver.observe(watch[wi]);
        }
      }
    }

    var glyphs = bg.querySelectorAll('.kl_reviews__lightbox__image_list > button svg');
    for (var g = 0; g < glyphs.length; g++) {
      if (!glyphs[g].getAttribute('viewBox')) {
        var gw = glyphs[g].getAttribute('width') || '16';
        var gh = glyphs[g].getAttribute('height') || '16';
        glyphs[g].setAttribute('viewBox', '0 0 ' + gw + ' ' + gh);
      }
    }

    if (!bg.__spKrHover) {
      bg.__spKrHover = 1;
      var HOT = 'sp-kr-lb-hot';
      var over = function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('.kl_reviews__lightbox__left, .kl_reviews__lightbox__image_list')) {
          bg.classList.add(HOT);
        } else {
          bg.classList.remove(HOT);
        }
      };
      bg.addEventListener('pointerover', over);
      bg.addEventListener('pointerout', function (e) {

        var to = e.relatedTarget;
        if (to && to.closest && to.closest('.kl_reviews__lightbox__left, .kl_reviews__lightbox__image_list')) return;
        bg.classList.remove(HOT);
      });
      bg.addEventListener('focusin', over);
    }

    var stageEl = bg.querySelector('.kl_reviews__lightbox__left');
    var media = stageEl ? stageEl.querySelectorAll('video, img') : [];
    for (var i = 0; i < media.length; i++) {
      var v = media[i];
      var deg = (rotationFor(v) % 360 + 360) % 360;
      if (!deg) {
        if (v.getAttribute('data-sp-kr-rotated')) {
          v.removeAttribute('data-sp-kr-rotated');
          v.style.cssText = '';
        }
        if (v.tagName === 'VIDEO') { dropBar(v); ensurePlayOverlay(v); }
        continue;
      }
      var host = v.parentElement ? v.parentElement.getBoundingClientRect() : null;
      if (!host || !host.width || !host.height) continue;

      var quarter = deg % 180 !== 0;
      v.setAttribute('data-sp-kr-rotated', String(deg));
      v.style.position = 'absolute';
      v.style.left = '50%';
      v.style.top = '50%';
      v.style.width = Math.round(quarter ? host.height : host.width) + 'px';
      v.style.height = Math.round(quarter ? host.width : host.height) + 'px';
      v.style.maxWidth = 'none';
      v.style.maxHeight = 'none';
      v.style.objectFit = 'contain';
      v.style.transform = 'translate(-50%, -50%) rotate(' + deg + 'deg)';
      if (v.tagName === 'VIDEO') { ensureBar(v); ensurePlayOverlay(v); }
    }
  }

  function watchLightbox() {
    if (window.__spKrLbWatch) return;
    window.__spKrLbWatch = 1;
    if (!window.MutationObserver) return;

    var settle = function () {
      layoutLightbox();
      requestAnimationFrame(layoutLightbox);
      setTimeout(layoutLightbox, 120);
      setTimeout(layoutLightbox, 400);
    };

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes.length || records[i].removedNodes.length) {
          settle();
          return;
        }
      }
    }).observe(document.body, { childList: true });
  }

  function dropLowest(wrap) {
    var o = wrap.querySelector('#kl_reviews__sort_by_reviews option[value="2"]');
    if (o) o.remove();
  }

  function boot() {
    var wrap = document.querySelector(WRAP);
    if (!wrap) return false;

    installLightboxDismiss();
    installBar();
    installPlayingWatch();

    var hold = makeHolder(wrap);
    var highlight = makeHighlighter(wrap);
    var run = function () { dropLowest(wrap); dedupe(wrap); hideStale(wrap); hold(); highlight(); layoutLightbox(); };
    run();

    wrap.addEventListener('input', highlight);
    window.addEventListener('resize', layoutLightbox);

    if (!window.MutationObserver) return true;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;

      Promise.resolve().then(function () { queued = false; run(); });
    }).observe(wrap, { childList: true, subtree: true });
    return true;
  }

  function start() {

    installFetchGuard();
    installLightboxDismiss();
    installBar();
    installPlayingWatch();
    watchLightbox();
    if (boot()) return;
    var tries = 0;
    var poll = setInterval(function () {
      if (boot() || ++tries > 60) clearInterval(poll);
    }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
